const inViewOnce = (element, animations, options = { margin: `0px 0px -${window.innerHeight * 0.5}px 0px` }) => {
  const { inView, animate } = window.Motion;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    animations.forEach((animation) => {
      const finalState = Object.keys(animation.animation).reduce((acc, key) => {
        const value = animation.animation[key];
        acc[key] = Array.isArray(value) ? value.at(-1) : value;
        return acc;
      }, {});
      animate(animation.element, finalState, { duration: 0 });
    });
    return;
  }

  const stop = inView(
    element,
    () => {
      animations.forEach((animation) => {
        animate(animation.element, animation.animation, animation?.ease ?? { ease: 'easeOut', duration: 0.5 });
      });
      stop();
    },
    options
  );
};

window.inViewOnce = inViewOnce;
